import React from "react";
import Nav from "react-bootstrap/Nav";

const DesignerMenuItem = ({url, menu_item, designer, classname, show_designers_menu}) => {
    return (
        <Nav.Item
            className={`${classname} nav-link nav-top-link`}
            as="a"
            href={show_designers_menu ? `${url}${encodeURIComponent(designer.slug)}` : `${url}?${menu_item.other_filter_key}=${encodeURIComponent(designer.name)}`}
        >
            {designer.is_new === true && <span className="top-nav__new-label">New</span>}
            {designer.name}
        </Nav.Item>
    );
}

export default DesignerMenuItem;